import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

interface SavePublishedDialogProps {
  open: boolean
  saving: boolean
  refusal?: string
  onClose: () => void
  onConfirm: () => void
}

/**
 * Confirm before a live policy changes under the members on it.
 *
 * A draft save is private and reversible; this one is neither. There is no un-publish and no
 * staging copy of a published configuration, so the edit reaches whoever is enrolled as soon as it
 * is stored — which is worth one deliberate click, even though the endpoint allows the write.
 */
export const SavePublishedDialog = ({
  open,
  saving,
  refusal,
  onClose,
  onConfirm,
}: SavePublishedDialogProps) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
    <DialogTitle>Save changes to a published policy?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        This policy is live for its effective period, so members see these values. The change takes
        effect as soon as it is saved and there is no un-publish — correcting it means saving again.
      </DialogContentText>
      {refusal && (
        <Alert severity="error" sx={{ mt: 2 }} data-testid="save-published-refusal">
          {refusal}
        </Alert>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button
        variant="contained"
        onClick={onConfirm}
        disabled={saving}
        data-testid="save-published-confirm"
      >
        Save changes
      </Button>
    </DialogActions>
  </Dialog>
)
